<template>
  <div id="q-app">
    <router-view />
  </div>
</template>
<script>
import cookieWarning from "./components/cookieWarning.vue";
import { defineComponent } from "vue";
import emitter from "tiny-emitter/instance";

export default defineComponent({
  name: "App",

  created() {
    window.addEventListener("keydown", this.shortcutEmmiter);
  },

  components: {
    cookieWarning,
  },

  methods: {
    shortcutEmmiter(e) {
      if (e.ctrlKey === true) {
        // ctrl dependent events
        if (e.code === "Space") emitter.emit("ctrlkey:space");
        if (e.code === "Delete") emitter.emit("ctrlkey:delete");
        if (e.code === "KeyI") emitter.emit("ctrlkey:i");
        if (e.code === "KeyA") emitter.emit("ctrlkey:a");
        if (e.code === "KeyM") emitter.emit("ctrlkey:m");
        if (e.code === "KeyS") emitter.emit("ctrlkey:s");
        if (e.code === "KeyD") emitter.emit("ctrlkey:d");
      } else {
        // not ctrl dependent events
        if (e.code === "F2") emitter.emit("key:f2");
        if (e.code === "F3") emitter.emit("key:f3");
        if (e.code === "Insert") emitter.emit("key:insert");
        if (e.code === "ArrowRight") emitter.emit("key:arrowRight");
        if (e.code === "ArrowLeft") emitter.emit("key:arrowLeft");
        if (e.code === "Enter") emitter.emit("key:enter");
        if (e.code === "Escape") emitter.emit("key:esc");
        if (e.code === "KeyA") emitter.emit("key:a");
        if (e.code === "KeyM") emitter.emit("key:m");
        if (e.code === "KeyS") emitter.emit("key:s");
        if (e.code === "KeyD") emitter.emit("key:d");
      }
    },
  },
});
</script>
